export const getDevice = () => {
    return Math.min(window.screen.width, window.screen.height) < 768 ||
        navigator.userAgent.indexOf('Mobi') > -1
        ? 'mobile'
        : 'desktop'
}
